import { create } from 'zustand'

import { devtools } from 'zustand/middleware'

import { delayHttpRequest } from '../helpers/globalHelper'
import { shiftService } from '../services/shiftService'
import {
  GiveUpShift,
  openshifts,
  response,
  shiftDetails,
  shiftstatusData,
  eccodedata,
  LeaveBalanceResponse
} from '../types/shiftTypes'

type Store = {
  loading: boolean
  error: null
  giveupData: GiveUpShift
  openshiftsData: openshifts
  shiftstatusData: shiftstatusData
  shifttimingsData: shiftDetails
  swapshiftData: any
  codelist: eccodedata
  leaveBalancesData: LeaveBalanceResponse | null
  updateGiveupShift: (
    shiftid: number,
    entityid: number,
    essuserkey: number,
    storeId: number
  ) => void
  getshifttimings: (date, id, entityId, storeId) => void
  getopenshifts: (obkey, startDate, endDate) => void
  pickupshift: (essuserkey: number, shiftid: number) => response
  swapshift: (feed) => response
  fetchstatus: (essuserkey: number) => void
  postData: (feed) => response
  fetchswapshiftDetails: (shiftid) => void
  submitPto: (ptorequest) => response
  clearData: () => void
  cleartimings: () => void
  geteccodelist: (entityId: number) => void
  ptoHistoryData: any
  getPTOHistory: (entityId: number, essUserKey: number, storeId: number) => void
  weekClockinsData: any
  fetchWeekclockins: (
    startDate: string,
    endDate: string,
    userId: number,
    entityId: number,
    storeId: number
  ) => void
  getLeaveBalances: (essUserKey: number) => Promise<any>
}

const useshiftstore = create(
  devtools<Store>((set) => ({
    loading: false,
    error: null,
    openshiftsData: null,
    giveupData: null,
    shifttimingsData: null,
    codelist: null,
    ptoHistoryData: null,
    weekClockinsData: null,
    leaveBalancesData: null,

    updateGiveupShift: async (
      shiftid,
      entityid,
      essuserkey,
      storeId: number
    ) => {
      set((state) => ({ ...state, loading: true }))
      try {
        return await shiftService.updateGiveupShift(
          shiftid,
          entityid,
          essuserkey,
          storeId
        )
        //const _Data=await shiftService.updateGiveupShift(shiftid, entityid, essuserkey,storeId)
        //set((state) => ({ ...state, giveupData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    pickupshift: async (essuserkey: number, shiftid: number) => {
      set((state) => ({ ...state, loading: true }))
      try {
        return await shiftService.Pickup(essuserkey, shiftid)
        //set((state) => ({ ...state, giveupData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    getshifttimings: async (date, id, entityId, storeId) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _Data = await shiftService.getshifttimings(
          date,
          id,
          entityId,
          storeId
        )
        set((state) => ({ ...state, shifttimingsData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getopenshifts: async (obkey, startDate, endDate) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _Data = await shiftService.getopenshifts(
          obkey,
          startDate,
          endDate
        )
        set((state) => ({ ...state, openshiftsData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    swapshift: async (feed) => {
      set((state) => ({ ...state, loading: true }))
      try {
        return await shiftService.swapshift(feed)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postData: async (feed) => {
      set((state) => ({ ...state, loading: true }))
      try {
        return await shiftService.postData(feed)
        // set((state) => ({ ...state, scheduleData: _scheduleData }))

        // fetch home data
        // useHomeStore.getState().fetchData(id)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchstatus: async (essUserKey) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _Data = await shiftService.fetchstatus(essUserKey)
        set((state) => ({ ...state, shiftstatusData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchswapshiftDetails: async (shiftid) => {
      set((state) => ({ ...state, loading: true }))
      try {
        return await shiftService.fetchswapshiftDetails(shiftid)
        //const _Data = await shiftService.fetchswapshiftDetails(shiftid)
        //set((state) => ({ ...state, swapshiftData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    submitPto: async (ptorequest) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const result = await shiftService.submitPto(ptorequest)
        return result
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    cleartimings: () => {
      set({ shifttimingsData: null })
    },
    clearData: () => {
      set({
        loading: false,
        error: null,
        openshiftsData: null,
        giveupData: null,
        shifttimingsData: null,
        ptoHistoryData: null,
        leaveBalancesData: null
      })
    },
    geteccodelist: async (entityId: number) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const result = await shiftService.geteccodelist(entityId)
        set((state) => ({ ...state, codelist: result }))
      } catch (error) {
        set((state) => ({ ...state, error: error.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getPTOHistory: async (entityId, essUserKey, storeId) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _ptoHistoryData = await shiftService.getPTOHistory(
          entityId,
          essUserKey,
          storeId
        )
        set((state) => ({ ...state, ptoHistoryData: _ptoHistoryData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchWeekclockins: async (
      startDate,
      endDate,
      userId,
      entityId,
      storeId
    ) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _data = await shiftService.fetchWeekclockins(
          startDate,
          endDate,
          userId,
          entityId,
          storeId
        )
        set((state) => ({ ...state, weekClockinsData: _data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getLeaveBalances: async (essUserKey: number) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _data = await shiftService.getLeaveBalances(essUserKey)
        set((state) => ({ ...state, leaveBalancesData: _data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    }
  }))
)

export { useshiftstore }
